import { Contract, VisibleColumnSpec } from "@/types";

export const DEFAULT_ARCHIVED_CONTRACT_COLUMN: VisibleColumnSpec<Contract, "counterParty" | "product" | "actions">[] = [
  "id",
  "counterParty",
  { id: "contractStartDate", breakpoint: "mantine-visible-from-xs" },
  { id: "contractEndDate", breakpoint: "mantine-visible-from-xl" },
  { id: "archivedDate", breakpoint: "mantine-visible-from-sm" },
  { id: "amount", breakpoint: "mantine-visible-from-xs" },
  // { id: "automaticSalesApproval", breakpoint: "mantine-visible-from-xl"},
  { id: "remainingAmount", breakpoint: "mantine-visible-from-lg" },
  { id: "contractType", breakpoint: "mantine-visible-from-md" },
  "actions",
];
